export default __webpack_public_path__ + "static/media/resume.a8ec0ec8.pdf";